(function () {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  // Reveal on scroll
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-inview');
          io.unobserve(e.target);
        }
      });
    },
    { threshold: 0.18 }
  );

  document.querySelectorAll('.sp-motion').forEach((el) => io.observe(el));

  // Subtle parallax (only for elements you mark with .sp-parallax)
  const parallaxEls = Array.from(document.querySelectorAll('.sp-parallax'));
  if (!parallaxEls.length) return;

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;

    requestAnimationFrame(() => {
      const vh = window.innerHeight || 800;
      parallaxEls.forEach((el) => {
        const rect = el.getBoundingClientRect();
        // Move up/down slightly as it enters viewport
        const progress = (rect.top - vh) / (vh + rect.height);
        const amount = Math.max(-18, Math.min(18, progress * -18)); // clamp
        el.style.setProperty('--sp-parallax', `${amount}px`);
      });
      ticking = false;
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();